import CreditCountBadge from './credit-count-badge'

export default CreditCountBadge
